/** Persistent returning-buyer delivery page for one active Vault entitlement. */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as api from '../api';
import { VaultItem } from '../types';
import { DownloadPanel } from '../components/DownloadPanel';
import { ShopTabs } from '../components/ShopTabs';
import { GhostBtn, PageShell, s } from '../ui';

const VaultDeliveryPage: React.FC = () => {
  const { entitlementId } = useParams<{ entitlementId: string }>();
  const navigate = useNavigate();
  const [item, setItem] = useState<VaultItem | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!entitlementId) {
      setError('This purchase could not be found.');
      return;
    }
    api.getVaultItem(entitlementId)
      .then(setItem)
      .catch((err) => setError(err.message || 'This purchase could not be found.'));
  }, [entitlementId]);

  return (
    <PageShell>
      <ShopTabs active="vault" />
      {!item && !error && <div style={s('color:var(--bs-text-muted);padding:40px 0')}>Loading purchased files…</div>}
      {error && (
        <div style={s('text-align:center;padding:70px 0;color:var(--bs-text-muted)')}>
          {error}
          <div style={s('margin-top:18px')}>
            <GhostBtn onClick={() => navigate('/store/beat-shop/vault')}>Back to My Vault</GhostBtn>
          </div>
        </div>
      )}
      {item && (
        <DownloadPanel
          mode="vault"
          entitlementId={item.entitlement_id}
          beat={{
            id: item.beat_id,
            name: item.name,
            bpm: item.bpm,
            musical_key: item.musical_key,
            files: item.files,
          }}
          onBack={() => navigate('/store/beat-shop/vault')}
        />
      )}
    </PageShell>
  );
};

export default VaultDeliveryPage;
